import { render, staticRenderFns } from "./FormSub.vue?vue&type=template&id=35e124aa"
import script from "./FormSub.vue?vue&type=script&lang=js"
export * from "./FormSub.vue?vue&type=script&lang=js"
import style0 from "./FormSub.vue?vue&type=style&index=0&id=35e124aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports